import Immutable from 'immutable';

// This is the initial client-side state of the entire store. (May be merged with server-side state __REDUX_STATE__ in index.js)
const initialStoreState = {
    //...reduxState,
    auth : { // info about currently logged in user
        isAuthenticated: false,
        isAuthenticating: false,
        forceAuthRecheck: false, // a signal to requireauth.js that it should recheck auth, and if user is logged out from the backend, a dialog should be displayed informing the user he has been logged out.
        statusText: null,
        // From Drupal passport strategy.
        id: null,
        displayName: null,
        emails: [],
        isMainAdmin: false,
        isSectionAdmin: false,
        isClubAdmin: false,
        clubNumber: null,
        adminSections: null,
        adminClubs: null,
        currentRole: null,
        currentEntity: null,
        // Only for local passport strategy. Not in use, as Drupal is used for single signon.
        userId: null,
        email: null,
        roleId: null,
        firstName: null,
        lastName: null,
        photo: null,
        photoMimeType: null,
        database: 'standard',
    },
    // Actually not used for this project.
    user : {
        isCreating: false,
        isCreated: false,
        statusText: null,
        username: null,  // this is the user which was created during the signup process... not the logged in user. See auth for that.
        isFetching: false,
        isFetched: false,
        users: new Immutable.Map(),
        user: {}, // user to view (can be any user - not necessarily the currently logged in user)
        emailExists: {name: null, exists: false},
        isSaving: false,
    },
    admin : {
        isBasicsRead: false,
        isClubsRead: false,
        isMembersRead: false,
        isChampionshipsRead: false,
        clubs: new Immutable.Map(),
        championships: new Immutable.Map(),
        pigeonHoles : new Immutable.Map(),
        members: new Immutable.Map(),
        sections: new Immutable.Map(),
        ranges: new Immutable.Map(),
        stations: new Immutable.Map(),
        zipCodes: new Immutable.Map(),
        nightTimes: new Immutable.Map(),
        derby: new Immutable.Map(),
        stationSelections: new Immutable.Map(),
        errorLists: {
            files: new Immutable.Map(),
            rings: new Immutable.Map(),
            pigeons: new Immutable.Map(),
            dm: new Immutable.Map(),
            signups: new Immutable.Map(),
            watches: new Immutable.Map(),
            membergames: new Immutable.Map(),
            financials: new Immutable.Map(),
            submissions: new Immutable.Map(),
            memberprogramusers: new Immutable.Map(),
            status: new Immutable.Map(),
        },
        userRoles: [],
        archives: [],
    },
    race : {
        isRacesRead: false,
        races: new Immutable.Map(),
        racePigeons: new Immutable.Map(),
        activePigeons: new Immutable.Map(),
        racePrices: new Immutable.Map(),
        deposits: new Immutable.Map(),
        markings: new Immutable.Map(),
        deviceImports: new Immutable.Map(),
        deviceImporterVersion: null,
        deviceComPorts: '',
    },
    globalError: { // The errors added in here, are global and opens and shows the error to the user in the main error-dialog (Could be extended so not all of them did that).
                   // Purpose: To show an error to the user on ajax calls which unexpectedly fails, instead of not giving the user any feedback (instead of silently ignoring it).
        errors: new Immutable.List() // <- When this list is non-empty, we have errors we need to display to the user.
    },
    system: {
        locationPath: "/",
        imageCacheBreaker: 0 // This value is added to image-URLs, so that when a user/organisation/etc updates his own image, the change is visible immediately without a page-load (works around browser *in-memory* caches (not HTTP-caches - that works fine)).
                             // Example: When a user has updated his profile, this variable is set to a new random value (which are added to the <img>-src URLs, so that all his images will update immediately).
                             //          This is better than a usual random value, in that: 1) it only breaks the cache when needed, 2) since this variable is in the store, all image-components can rerender exactly when it's changed.
                             //          And 3) since it always start at 0, caching works normally until a user/organisation/etc edits his profile.
                             //          (Of course, if another user updates his profile on his computer, you would still have to reload the page to see the changes. Acceptable i think. (One COULD fetch all user-objects for all images to show, but that seems really slow - could also use a setTimeout()))
    },
};

export default initialStoreState;


// WEBPACK FOOTER //
// ./src/client/src/store/initialstorestate.js